<template>
  <el-form-item prop="variableArr" ref="formItem" verify :rules="variableArrRules" class="sky-feature-competitive">
    <div class="el-icon-question wsp-padding-lr-6 wsp-line-height-24" style="color:#38A4F5">
      竞争力信息中【相比友商】不确定时可选择其他
    </div>
    <div :class="['sky-feature-competitive__item', 'sk-font--B']" v-for="(item, index) in variableArr" :key="index">
      <div class="arr-item">
        <div class="arr-item-title ">相比友商：</div>
        <div class="arr-item-value  must-input">
          <el-select
            placeholder="请选择友商"
            v-model="item.competitor"
            popper-class="sky-feature-competitive__autocomplete"
            :class="`sky-feature-competitive__select ${hasError && !item.competitor ? 'input-error' : ''}`"
            filterable
          >
            <el-option v-for="(item, index) in competitorList" :key="index" :label="$t(item.label)" :value="item.id">
            </el-option>
          </el-select>
          <i v-if="index != 0" class="sk-icon-remove sk-font--B" @click="handleDelete(index)"></i>
        </div>
      </div>
      <div class="arr-item">
        <div class="arr-item-title ">竞争力：</div>
        <div class="arr-item-value  must-input">
          <el-select
            placeholder="请选择竞争力"
            v-model="item.competitiveness"
            popper-class="sky-feature-competitive__autocomplete"
            :class="`sky-feature-competitive__select ${hasError && !item.competitiveness ? 'input-error' : ''}`"
            filterable
          >
            <el-option
              v-for="(item, index) in competitivenessList"
              :key="index"
              :label="$t(item.label)"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="arr-item">
        <div class="arr-item-title">竞争力说明：</div>
        <div class="arr-item-value">
          <el-input
            placeholder="请输入竞争力说明"
            v-model="item.competitiveComparison"
            class="sky-feature-competitive__textarea"
            type="textarea"
            :rows="3"
          ></el-input>
        </div>
      </div>
      <div v-if="index + 1 != variableArr.length" class="arr-item arr-item-sep"></div>
    </div>
    <el-button type="text" class="el-icon-plus sky-branch-pattern__add" style="margin-top:5px" @click="handleAdd">
      添加竞争力信息
    </el-button>
  </el-form-item>
</template>
<script type="text/babel">
import { Select, Option, Input, Button } from 'element-ui'
import { action } from 'sky-engine/api'

import { COMMON_MNG } from '@/api/apiModules'
export default {
  name: 'SkyFeatureCompetitiveRelate',
  inject: ['rootView', 'elForm'],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [Button.name]: Button
  },
  props: {
    value: {
      type: [String, Array, Object],
      default: ''
    }
  },
  data() {
    return {
      variableArr: [
        {
          competitor: null,
          competitiveness: null,
          competitiveComparison: null
        }
      ],
      loading: false,
      hasError: false,
      competitivenessList: [
        {
          id: '优势',
          label: '优势'
        },
        {
          id: '劣势',
          label: '劣势'
        },
        {
          id: '持平',
          label: '持平'
        },
        {
          id: '未知',
          label: '未知'
        }
      ],
      competitorList: []
    }
  },
  mounted() {
    action(COMMON_MNG, 'projectCompetitor').then(response => {
      this.competitorList = response.data.content.itemArr.map(item => {
        return {
          id: item.id,
          label: item.label
        }
      })
    })
  },
  computed: {
    variableArrRules() {
      const validatorBranch = (rule, value, callback) => {
        this.hasError = false
        for (const item of this.variableArr) {
          if (!this.isFill(item)) {
            this.hasError = true
            callback(new Error(this.$t('请选择相比友商与竞争力')))
          }
        }
        if (this.isDuplicate()) {
          this.hasError = true
          callback(new Error(this.$t('选择的相比友商不能重复')))
        }
        if (!this.hasError) {
          callback()
        }
      }
      return [[{ validator: validatorBranch, trigger: ['blur', 'change'] }]]
    }
  },
  watch: {
    value(value) {
      if (this.value?.length) {
        this.handleFill(value)
      }
    },
    variableArr: {
      handler: function(value) {
        this.$emit('input', value)
      },
      deep: true
    }
  },
  methods: {
    isFill(item) {
      return item.competitor && item.competitiveness
    },
    handleFill(value) {
      this.variableArr = value
      this.$emit('input', this.variableArr)
    },
    handleAdd() {
      this.variableArr.push({
        competitor: null,
        competitiveness: null,
        competitiveComparison: null
      })
    },
    handleDelete(index) {
      this.variableArr.splice(index, 1)
    },
    isDuplicate() {
      if (this.variableArr.length) {
        const set = new Set()
        return this.variableArr.some(obj => {
          const competitor = obj['competitor']
          if (set.has(competitor)) {
            return true
          } else {
            set.add(competitor)
          }
        })
      }
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';

@include b(version-variable) {
  @include e(more-btn) {
    & .el-button {
      background-color: $--fill-base !important;
      color: $--color-primary !important;
      border: 0 !important;
      line-height: $--font-line-height-base - 0.2em;
      &:hover {
        color: $--color-primary-5 !important;
      }
    }
  }
}

.el-form-item.is-error .sky-feature-competitive__item .el-input__inner {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}
@include b(feature-competitive) {
  margin-bottom: 0px !important;
  @include e(autocomplete) {
    width: auto !important;
    min-width: 300px;
  }
  @include e(select) {
    width: 290px !important;
  }
  @include e(textarea) {
    width: 300px !important;
  }

  @include e(multiple-select) {
    width: 300px !important;
  }

  @include e(item) {
    line-height: 36px;
    word-break: break-all;
    width: 800px !important;

    .arr-item {
      display: flex;
      .arr-item-title {
        padding: 0 12px;
        width: 15%;
        line-height: 36px;
      }
      .input-error {
        .el-input__inner {
          border-bottom: 1px solid #df1b1b !important;
        }
      }
    }
    .arr-item-sep {
      margin-top: 10px;
      border-bottom: 1px solid gray;
      width: 55%;
    }

    .must-input:before {
      content: '*';
      color: #df1b1b;
      margin-right: 0.16667rem;
    }
  }
  & i {
    margin-right: 5px;
    color: #df1b1b;
    cursor: pointer;
  }
  & .el-input__inner {
    border-top: 0;
    border-left: 0;
    border-right: 0;
    padding: 0;
  }
  & .el-form-item__error {
    width: 500px !important;
  }
}
</style>
